import Webcallback from "components/templates/webcallback/Webcallback";
import elementsTypes from "utils/elementsTypes";

export default {
  key: "WEBCALLBACK",
  label: "WebCallback (AKIO)",
  Component: Webcallback,
  initialContents: [
    {
      key: "CallbackReasonsList",
      type: elementsTypes.CALLBACK_REASON_LIST,
      value: "",
      children: [
        {
          key: "CallbackReasons",
          type: elementsTypes.CALLBACK_REASON,
          value: "",
          children: [
            {
              key: "title",
              type: elementsTypes.INPUT,
              value: "L’accès à mon compte",
            },
            {
              key: "value",
              type: elementsTypes.INPUT,
              value: "errorAccount",
            },
          ],
        },
        {
          key: "CallbackReasons",
          type: elementsTypes.CALLBACK_REASON,
          value: "",
          children: [
            {
              key: "title",
              type: elementsTypes.INPUT,
              value: "Une demande de permis de conduire",
            },
            {
              key: "value",
              type: elementsTypes.INPUT,
              value: "wcbpdc",
            },
          ],
        },
        {
          key: "CallbackReasons",
          type: elementsTypes.CALLBACK_REASON,
          value: "",
          children: [
            {
              key: "title",
              type: elementsTypes.INPUT,
              value: "Une demande d’immatriculation",
            },
            {
              key: "value",
              type: elementsTypes.INPUT,
              value: "wcbsiv",
            },
          ],
        },
        {
          key: "CallbackReasons",
          type: elementsTypes.CALLBACK_REASON,
          value: "",
          children: [
            {
              key: "title",
              type: elementsTypes.INPUT,
              value: "Une demande de carte d’identité ou passeport",
            },
            {
              key: "value",
              type: elementsTypes.INPUT,
              value: "errorPassport",
            },
          ],
        },
        {
          key: "CallbackReasons",
          type: elementsTypes.CALLBACK_REASON,
          value: "",
          children: [
            {
              key: "title",
              type: elementsTypes.INPUT,
              value: "France identité",
            },
            {
              key: "value",
              type: elementsTypes.INPUT,
              value: "errorFI",
            },
          ],
        },
      ],
    },
  ],
};
